var $8uLkp$swchelperscjs_class_call_checkcjs = require("@swc/helpers/cjs/_class_call_check.cjs");
var $8uLkp$swchelperscjs_async_iteratorcjs = require("@swc/helpers/cjs/_async_iterator.cjs");
var $8uLkp$swchelperscjs_async_to_generatorcjs = require("@swc/helpers/cjs/_async_to_generator.cjs");
var $8uLkp$swchelperscjs_create_classcjs = require("@swc/helpers/cjs/_create_class.cjs");
var $8uLkp$swchelperscjs_to_consumable_arraycjs = require("@swc/helpers/cjs/_to_consumable_array.cjs");
var $8uLkp$swchelperscjs_wrap_async_generatorcjs = require("@swc/helpers/cjs/_wrap_async_generator.cjs");
var $8uLkp$swchelperscjs_ts_generatorcjs = require("@swc/helpers/cjs/_ts_generator.cjs");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $2cb42c256f4cab10$exports = {};

$parcel$export($2cb42c256f4cab10$exports, "Defer", function () { return $2cb42c256f4cab10$export$c7e91f8aec23ae14; });
$parcel$export($2cb42c256f4cab10$exports, "makeDefer", function () { return $2cb42c256f4cab10$export$51ca94569b882c51; });

var $2cb42c256f4cab10$export$c7e91f8aec23ae14 = function Defer() {
    "use strict";
    var _this = this;
    (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, Defer);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
var $2cb42c256f4cab10$export$51ca94569b882c51 = function() {
    return new $2cb42c256f4cab10$export$c7e91f8aec23ae14();
};


var $4ca06aa81cd650aa$exports = {};

$parcel$export($4ca06aa81cd650aa$exports, "Observable", function () { return $4ca06aa81cd650aa$export$77cea355fa80b5f4; });








if (!Symbol.observable) Reflect.set(Symbol, 'observable', Symbol('observable'));
var $4ca06aa81cd650aa$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    "use strict";
    function Observable(subscriber) {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, Observable);
        this.subscriber = subscriber;
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(Observable, [
        {
            key: Symbol.observable,
            value: function value() {
                return this;
            }
        },
        {
            key: Symbol.asyncIterator,
            value: function value() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function() {
                    var queue, canceler, done, observer;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queue = [
                                    new (0, $2cb42c256f4cab10$export$c7e91f8aec23ae14)()
                                ], done = false;
                                observer = {
                                    next: function(value) {
                                        if (done) return;
                                        queue[queue.length - 1].resolve(value);
                                        queue.push(new (0, $2cb42c256f4cab10$export$c7e91f8aec23ae14)());
                                    },
                                    error: function(reason) {
                                        if (!done) {
                                            queue[queue.length - 1].reject(reason);
                                            done = true;
                                        }
                                        if (canceler) canceler();
                                    },
                                    complete: function() {
                                        if (!done) {
                                            queue[queue.length - 1].resolve();
                                            done = true;
                                        }
                                        if (canceler) canceler();
                                    }
                                };
                                canceler = this.subscriber(observer);
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    queue[0].promise
                                ];
                            case 2:
                                _state.sent();
                                queue.shift();
                                _state.label = 3;
                            case 3:
                                if (queue[0]) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                    var stack, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stack = [];
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $8uLkp$swchelperscjs_async_iteratorcjs._)(this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                stack.push(item);
                                if (stack.length > 2) stack.shift();
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    stack[0]
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(onNext, onError, onComplete) {
                var _this = this;
                var stop = false;
                (function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, error;
                        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        13,
                                        ,
                                        14
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        7,
                                        12
                                    ]);
                                    _iterator = (0, $8uLkp$swchelperscjs_async_iteratorcjs._)(this);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        _iterator.next()
                                    ];
                                case 3:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        5
                                    ];
                                    _value = _step.value;
                                    item = _value;
                                    if (!stop) onNext(item);
                                    else return [
                                        3,
                                        5
                                    ];
                                    _state.label = 4;
                                case 4:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        12
                                    ];
                                case 6:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        12
                                    ];
                                case 7:
                                    _state.trys.push([
                                        7,
                                        ,
                                        10,
                                        11
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                        3,
                                        9
                                    ];
                                    return [
                                        4,
                                        _iterator.return()
                                    ];
                                case 8:
                                    _state.sent();
                                    _state.label = 9;
                                case 9:
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 11:
                                    return [
                                        7
                                    ];
                                case 12:
                                    if (onComplete instanceof Function) onComplete();
                                    return [
                                        3,
                                        14
                                    ];
                                case 13:
                                    error = _state.sent();
                                    if (onError instanceof Function) onError(error instanceof Error || typeof error === 'string' ? error : new Error(error + ''));
                                    return [
                                        3,
                                        14
                                    ];
                                case 14:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                })();
                return {
                    unsubscribe: function() {
                        return stop = true;
                    },
                    get closed () {
                        return stop;
                    }
                };
            }
        }
    ], [
        {
            key: "fromStream",
            value: function fromStream(list) {
                return new this(function(param) {
                    var next = param.next, complete = param.complete, error = param.error;
                    var stopped = false;
                    (function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, bug;
                            return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            13,
                                            ,
                                            14
                                        ]);
                                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            7,
                                            12
                                        ]);
                                        _iterator = (0, $8uLkp$swchelperscjs_async_iteratorcjs._)(list);
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            _iterator.next()
                                        ];
                                    case 3:
                                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                            3,
                                            5
                                        ];
                                        _value = _step.value;
                                        item = _value;
                                        if (!stopped) next(item);
                                        else return [
                                            3,
                                            5
                                        ];
                                        _state.label = 4;
                                    case 4:
                                        _iteratorAbruptCompletion = false;
                                        return [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            12
                                        ];
                                    case 6:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            12
                                        ];
                                    case 7:
                                        _state.trys.push([
                                            7,
                                            ,
                                            10,
                                            11
                                        ]);
                                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                            3,
                                            9
                                        ];
                                        return [
                                            4,
                                            _iterator.return()
                                        ];
                                    case 8:
                                        _state.sent();
                                        _state.label = 9;
                                    case 9:
                                        return [
                                            3,
                                            11
                                        ];
                                    case 10:
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                        return [
                                            7
                                        ];
                                    case 11:
                                        return [
                                            7
                                        ];
                                    case 12:
                                        if (!stopped) complete();
                                        return [
                                            3,
                                            14
                                        ];
                                    case 13:
                                        bug = _state.sent();
                                        if (!stopped) error(bug instanceof Error || typeof bug === 'string' ? bug : new Error(bug + ''));
                                        return [
                                            3,
                                            14
                                        ];
                                    case 14:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    })();
                    return function() {
                        return stopped = true;
                    };
                });
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return this.fromStream(items);
            }
        },
        {
            key: "from",
            value: function from(observable) {
                if (Symbol.iterator in observable) return this.of.apply(this, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(observable));
                if (Symbol.asyncIterator in observable) return this.fromStream(observable);
                return new this(function(param) {
                    var next = param.next, error = param.error, complete = param.complete;
                    return observable.subscribe(next, error, complete).unsubscribe;
                });
            }
        },
        {
            key: "fromEvent",
            value: function fromEvent(target, name) {
                return new this(function(param) {
                    var next = param.next, error = param.error;
                    if (typeof target.on === 'function') target.on(name, next).on('error', error);
                    else {
                        target.addEventListener(name, next);
                        target.addEventListener('error', error);
                    }
                    return function() {
                        if (typeof target.off === 'function') target.off(name, next).off('error', error);
                        else {
                            target.removeEventListener(name, next);
                            target.removeEventListener('error', error);
                        }
                    };
                });
            }
        }
    ]);
    return Observable;
}();


var $54ff1c6f8702dbfb$exports = {};

$parcel$export($54ff1c6f8702dbfb$exports, "createQueue", function () { return $54ff1c6f8702dbfb$export$d16acf4b6e75743d; });


function $54ff1c6f8702dbfb$export$d16acf4b6e75743d() {
    var feedNext, stop;
    var observable = new (0, $4ca06aa81cd650aa$export$77cea355fa80b5f4)(function(param) {
        var next = param.next, complete = param.complete;
        feedNext = next, stop = complete;
    });
    return {
        process: function(data) {
            var defer = new (0, $2cb42c256f4cab10$export$c7e91f8aec23ae14)();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy: function() {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}


$parcel$exportWildcard(module.exports, $2cb42c256f4cab10$exports);
$parcel$exportWildcard(module.exports, $4ca06aa81cd650aa$exports);
$parcel$exportWildcard(module.exports, $54ff1c6f8702dbfb$exports);


//# sourceMappingURL=index.js.map
